var render, staticRenderFns
import script from "./ChartRadar.vue?vue&type=script&lang=js"
export * from "./ChartRadar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c162e67",
  null
  
)

export default component.exports